import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from '@material-ui/core';
import { BookmarksAttachmentRow } from '../../booth/AttachmentRow';
import ModalTitleBar from '../ModalTitleBar';
import { BookmarksContext } from './Bookmarks';


const NoBookmarkedAttachmentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
`;

const NoBookmarkedAttachment = () => (
  <NoBookmarkedAttachmentContainer> No bookmarked attachment </NoBookmarkedAttachmentContainer>
);

const BookmarksModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  max-width: 1200px;
  width: 100%;
  max-height: 620px;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  border-radius: 16px;
  padding: 20px;
  
  &:focus{
    outline:none;
  }
`;

const BookmarksList = styled.div`
  overflow-y: auto;
`;

const BookmarksModal = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose}>
    <BookmarksModalContainer>
      <ModalTitleBar onClose={onClose}> My Bookmark </ModalTitleBar>
      <BookmarksList>
        <BookmarksContext.Consumer>
          {({ bookmarkedAttachments, toggleBookmark }) => (
            Object.values(bookmarkedAttachments).length > 0
              ? Object.values(bookmarkedAttachments)
                .map((attachment) => (
                  <BookmarksAttachmentRow
                    key={attachment.id}
                    attachment={attachment}
                    onRemove={() => toggleBookmark(attachment)}
                  />
                ))
              : <NoBookmarkedAttachment />
          )}
        </BookmarksContext.Consumer>
      </BookmarksList>
    </BookmarksModalContainer>
  </Modal>
);

BookmarksModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BookmarksModal;
